// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ImhM","delete":"styles_delete__3ljOH","update":"styles_update__2TzuY","add":"styles_add__1CKeF"};